module.exports = __webpack_public_path__ + "img/furia.0ff3e451.png";